module.exports = __webpack_public_path__ + "img/gmsyt3.c6ac40af.png";